// extracted by mini-css-extract-plugin
export default {"input":"AdminMobileSearchInput_input__WH3Dk","search":"AdminMobileSearchInput_search__mQ3Lc"};